import type { NgZone } from "@angular/core";
import type { OperatorFunction } from "rxjs";
import { Observable } from "rxjs";

/**
 * Runs the upstream pipeline outside Angular's zone so that intermediate
 * timer-based operators (debounceTime, throttleTime, etc.) do not trigger
 * change detection. The final emission is delivered back **inside** the zone
 * so that the async pipe / subscribers can update the view.
 */
export function outsideZone<T>(zone: NgZone): OperatorFunction<T, T> {
  return (source: Observable<T>) =>
    new Observable<T>((subscriber) => {
      let sub: ReturnType<Observable<T>["subscribe"]>;
      zone.runOutsideAngular(() => {
        sub = source.subscribe({
          next: (value) => zone.run(() => subscriber.next(value)),
          error: (err) => zone.run(() => subscriber.error(err)),
          complete: () => zone.run(() => subscriber.complete()),
        });
      });
      return () => sub.unsubscribe();
    });
}
